<template>
    <div ref="content">
        <slot v-bind:count="count" v-bind:items="selectedItems" />
    </div>
</template>

<script>
import Vue from "vue";
import * as _ from "lodash";
import { initStore } from "../store/modules/card-selector";
import { mapState, mapGetters } from 'vuex'
export default {
    props: {
        data: [],
    },
    beforeCreate() {
        this.$store = initStore();
        this.$store.commit('initialiseStore');
    },
    mounted() {
        let text = this.$el.innerHTML;
        if(_.isString(text)){
            text = text.replace(/{count}/gi, this.count)
            this.$el.innerHTML = text;
            // this.$slots.default.text = text;
        }
    },
    computed: {
        ...mapGetters({
            selectedItems: 'selectedItems',
        }),
        count: function() {
            return this.selectedItems.length;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/app/components/aha-card-viewer-text.vue